import React from 'react';
import styled from "styled-components";
import Slide from "@/components/ParallaxSlider/Mobile/Slide";
import {getMapKey} from "@/utils/utils";
import Badge from "@/components/ParallaxSlider/Badge";

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	//height: 100svh;
	//> .pin-spacer{
	//	//margin: 0 !important;
	//	display: flex !important;
	//	width: 100% !important; 
	//} 
    img{
        object-position: center !important;
    }

    .slide:nth-of-type(even){
		--align: right;
    }
`

const ParallaxSliderMobile = ({ id='', header='', button = {}, slides=[] }) => {
	// console.log(slides);
	return (
		<Wrapper id={id}>
			{slides.map((slide, index) => (
				<Slide
					key={getMapKey(slide, index)}
					data={slide}
				/>
			))}
			<Badge data={button} />
		</Wrapper>
	);
};

export default ParallaxSliderMobile;
